module.exports = __webpack_public_path__ + "static/media/collection-lot-favorite-active.4f2e8041.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/collection-lot-favorite-active.svg
// module id = 1551
// module chunks = 0